import { useGateway } from '@ad-lucy/gateway-provider';
import {
  useFetchBirthdaysCountGqlQuery,
  useFetchCompaniesCountGqlQuery,
  useFetchContactsCountGqlQuery,
} from '@codegen';
import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import { getAppConfig } from '@modules/config/appConfig';
import { birthdaysQueryVariables } from '@modules/Layout/Default/Sidebar/Navbar/CrmNavBarMenu';
import RemoteCustomer from '@modules/remotes/customer';
import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';

export function AdmModuleCustomer() {
  const appConfig = getAppConfig();
  const navigate = useNavigate();
  const gateway = useGateway();

  const customerApConfig = {
    API_ROOT: appConfig.API_ROOT ?? '',
    IMG_URL: appConfig.IMG_URL ?? '',
    DOWNLOAD_URL: appConfig.DOWNLOAD_URL ?? '',
    FILE_URL: appConfig.FILE_URL ?? '',
    THEME_URL: appConfig.THEME_URL ?? '',
    THEME_DEFAULT: appConfig.THEME_DEFAULT ?? '',
  };

  const { refetch: refetchCompaniesCount } = useFetchCompaniesCountGqlQuery();
  const { refetch: refetchContactsCount } = useFetchContactsCountGqlQuery();
  const { refetch: refetchBirthdaysCount } = useFetchBirthdaysCountGqlQuery(
    birthdaysQueryVariables,
  );

  // to update the element count badges in the navbar, we need to pass all refetch functions to the customers module
  const onUpdateEntities = {
    // fetchCompaniesCountGql
    companies: () => {
      refetchCompaniesCount();
    },
    contacts: () => {
      // fetchContactsCountGql
      refetchContactsCount();
      // fetchBirthdaysCountGql
      refetchBirthdaysCount();
    },
  };
  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteCustomer
          gateway={gateway}
          appConfig={customerApConfig}
          handleGoToCampaigns={(accountId: string) => {
            navigate(`/campaigns?search=account:${accountId}`);
          }}
          refetchNavbarCount={onUpdateEntities}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
